import Component from 'components/pages/Rewards/EGiftCardRewards/EGiftCardRewards';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('rewards');
export default buildPage(Component, {
  requiresAuthentication: true,
  metaData: {
    title: 'e gift card rewards',
    description: 'E gift card rewards page',
  },
});
